// import { ToastrService } from 'ngx-toastr';
// import { Notyf } from 'notyf';
import { NotyfService } from 'ng-notyf';
import * as i0 from "@angular/core";
import * as i1 from "ng-notyf";
var NotificationService = /** @class */ (function () {
    // private notyf: Notyf = null;
    function NotificationService(
    // @Inject(Injector) private readonly injector: Injector
    // private notify: ToastrService
    notyfService) {
        this.notyfService = notyfService;
        // this.notify = this.injector.get(ToastrService);
        // this.notyf = new Notyf();
    }
    // private get notify(): ToastrService {
    //     // return this.injector.get(ToastrService);
    //     return this._notify;
    // }
    NotificationService.prototype.showError = function (message, title) {
        if (title === void 0) { title = ''; }
        // this.notyf.error(message);
        // this.notify.error(message, title);
        this.notyfService.error(message);
    };
    NotificationService.prototype.showSuccess = function (message, title) {
        if (title === void 0) { title = ''; }
        // this.notyf.success(message);
        // this.notify.success(message, title);
        this.notyfService.success(message);
    };
    NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1.NotyfService)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
export { NotificationService };
